<template>
    <div v-if="chartData" class="mvt-market">
        <mvtChart :data="chartData"></mvtChart>
    </div>
</template>
<script src="./mvt-market.js"></script>
<style lang="scss">
@use "./mvt-market.scss" as *;
</style>